import { atom } from "recoil";

export type CouponModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  modalData: any;
};

export const couponModalState = atom<CouponModalType>({
  key: "couponModal",
  default: {
    visibleConfirm: false,
    modalData: [],
  },
});
